import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import noop from 'lodash/noop';

type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastPayload {
  message: string;
  type: ToastType;
}

interface ToastState {
  message: string;
  type: ToastType;
  visible: boolean;
}

const initialState: ToastState = {
  message: '',
  type: 'info',
  visible: false,
};

export const toastReducer = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (_state: ToastState, _action: PayloadAction<ToastPayload>) => noop(),
    setToast: (state: ToastState, action: PayloadAction<ToastPayload>) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.visible = true;
    },
    hideToast: (state: ToastState) => {
      state.visible = false;
    },
  },
});
